import { Vector3 } from '@babylonjs/core';
import { EnemyDistributionConfig } from '../EnemyGenerator';
import { ENEMY_ANIMATIONS, EnemyBehavior } from './EnemyBehavior';

/**
 * Idle behavior - play idle animation, look at player when close
 */

export class EnemyIdleBehavior extends EnemyBehavior {
  constructor(startPosition: Vector3, config: EnemyDistributionConfig) {
    super('enemyIdle', startPosition, config);
  }

  behaviorUpdate(deltaTime: number): void {
    // Play idle animation
    this.playAnimation(ENEMY_ANIMATIONS.IDLE, true);

    // Ensure on ground
    this.snapToGround(deltaTime);

    // Optionally look at player when close
    if (this.getPlayerDistance() < 30) {
      this.lookAt(this.getPlayerPosition());
    }
  }

  clone(): EnemyIdleBehavior {
    return new EnemyIdleBehavior(this.startPosition, this.config);
  }
}
